import { Dispatch } from 'redux';
import { apiErrorClear } from '../../../../global/ducks/base-api';
import { getEmploymentPlans, postPensionEnrollment } from '../../../../global/ducks/benadmin-api';
import { getFormattedDateYmd } from '../../../../global/helpers/date-helpers';
import { PensionEnrollmentFormValues } from './models/pension-enrollment-form-model';
import { PensionEnrollmentPlan, PensionEnrollmentPlanType, PensionEnrollmentStep } from './models/pension-enrollment-model';
import { setPensionEnrollmentInfo, setPensionEnrollmentStep, setSuccessfulEnrolledPlan } from './pension-enrollment-slice';

export function enrollPensionPlan(dispatch: Dispatch<any>,
	values: PensionEnrollmentFormValues,
	selectedPlan: PensionEnrollmentPlan,
	employeeId: string,
	employmentId: number,
	onSuccess: () => void) {

	if (!selectedPlan) return;


	const formattedDate = getFormattedDateYmd(new Date(values.effective_date_year, values.effective_date_month - 1).toString());

	const payloadData: any = {
		enroll_on_plan: [`${selectedPlan.plan_id}_${selectedPlan.plan_type}`],
		enrollments: {
			enrollment: {
				'0': {
					plan_id: selectedPlan.plan_id,
					plan_type: selectedPlan.plan_type,
					pbpor_id: selectedPlan.pbpor_id,
					effective_date: formattedDate,
					employment_id: employmentId,
					bill_payer: values.bill_payer,
				},
			},
		},
		employee_id: employeeId,
		employment_id: employmentId,
	};

	if (values.contribution_type && (selectedPlan?.plan_type === PensionEnrollmentPlanType.RsvpPlan || selectedPlan?.plan_type === PensionEnrollmentPlanType.DcPlan)) {

		payloadData.enrollments.enrollment[0].pretax_contribution = values?.contribution_amount;
		payloadData.enrollments.enrollment[0].contribution_type  = values?.contribution_type;
	}

	dispatch(apiErrorClear());

	dispatch(postPensionEnrollment(employeeId, employmentId, payloadData, () => {
		dispatch(setSuccessfulEnrolledPlan(selectedPlan.pbpor_description));
		dispatch(getEmploymentPlans(employmentId, (getResponse) => {
			dispatch(setPensionEnrollmentStep(PensionEnrollmentStep.Landing));
			dispatch(setPensionEnrollmentInfo(getResponse));
			onSuccess();
		}));
	}));
}